export enum ProductTypeShortcut {
  AirAmbulance = 'AA',
  DutyOfCare = 'DoC',
  KidnapAndExtortion = 'KE',
  SecurityResponse = 'SR',
  TravelLicense = 'TL',
}
